/** Só números do valor informado (sem cortar dígitos). */
export function cepDigits(value: string): string {
  return value.replace(/\D/g, '');
}

/**
 * Valida CEP brasileiro: exatamente 8 dígitos e não pode ser sequência com todos os algarismos iguais.
 * Aceita com ou sem máscara (`00000-000`).
 */
export function validarCep(cep: string): boolean {
  const digits = cep.replace(/\D/g, '');

  if (!/^\d{8}$/.test(digits)) {
    return false;
  }

  if (/^(\d)\1{7}$/.test(digits)) {
    return false;
  }

  return true;
}

/** Alias em inglês (ex.: `PostalCodeForm`). */
export function isValidCep(value: string): boolean {
  return validarCep(value);
}
